import React, { useEffect, useState } from 'react';
import { Input, MultiSelect, MultiSelectOption } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import ErrorIcon from '../../../../assets/error.png';
import { convertArrayToString, convertStringToArray } from '../../../../utils';
import { isEmpty } from 'lodash';

export type MapStatePropsType = {};

export type DispatchPropsType = {
	validateNumber: (data: any, cb: (res: any) => void) => void;
	fetchFilters: (cb: (res: any) => void) => void;
};

export type AgentNumberPropsType = {
	value: any;
	onChange: (num: string) => void;
	setDisable: (val: any) => void;
	modeFilter?: boolean;
};

const AgentNumber: React.FC<
	MapStatePropsType & DispatchPropsType & AgentNumberPropsType
> = ({
	validateNumber,
	value,
	onChange,
	setDisable,
	modeFilter = false,
	fetchFilters,
}) => {
	const { t } = useTranslation();
	const [agentNumber, setAgentNumber] = useState<any>(value);
	const [change, setChange] = useState<any>({});
	const [agentNumbers, setAgentNumbers] = useState<string[]>([]);
	const [agentData, setAgentData] = useState<string[]>([]);

	const validateAgentNumber = (values: any = undefined) => {
		if (modeFilter) {
			if (values) {
				validateAPI(values);
			} else {
				let numbersEntry = convertArrayToString(agentNumbers);
				validateAPI(numbersEntry);
			}
		} else {
			validateAPI(agentNumber);
		}
	};
	const validateAPI = (values: string) => {
		validateNumber(
			{
				number: encodeURI(values),
			},
			(res) => {
				if (res?.code === '200') {
					setChange({
						...change,
						agentNumValid: true,
					});
					setDisable({
						...change,
						agentNumValid: true,
					});
				} else {
					setChange({
						...change,
						agentNumValid: false,
					});
					setDisable({
						...change,
						agentNumValid: false,
					});
				}
			}
		);
	};

	useEffect(() => {
		fetchFilters((res: any) => {
			if (!isEmpty(res)) {
				setAgentData(res?.data?.agent_number);
			}
		});
	}, []);

	const multiSelectValidation = (values: any) => {
		let regex = /^\+?(\d{0,14},)*(\+?\d{0,14}(?:,|$))+$/;
		if (!values?.length) {
			delete change.agentNumValid;
			setDisable({});
		}
		values.forEach((element: any) => {
			if (element && !regex.test(element)) return;
		});

		setAgentNumbers(values);
		onChange(values);
	};
	return (
		<>
			{!modeFilter ? (
				<Input
					value={agentNumber}
					label={t('agentNum')}
					placeholder={t('agentNum')}
					className={Styles.ipElement}
					onChange={(e) => {
						let value = e.target.value;
						let regex = /^\+?\d{0,14}$/;
						if (!value?.length) {
							delete change.agentNumValid;
							setDisable({});
						}
						if (value && !regex.test(value)) return;
						setAgentNumber(value);
						onChange(value);
					}}
					onBlur={() => {
						if (modeFilter) {
							if (agentNumber?.length) {
								validateAgentNumber();
							}
						} else {
							validateAgentNumber();
						}
					}}
					bottomLabelType={
						change.hasOwnProperty('agentNumValid')
							? change['agentNumValid']
								? undefined
								: 'error'
							: undefined
					}
					bottomLabel={
						change.hasOwnProperty('agentNumValid') ? (
							change['agentNumValid'] ? undefined : (
								<span>
									<img
										style={{ marginRight: '0.5rem' }}
										src={ErrorIcon}
										className={Styles.errorIcon}
										alt=""
									/>
									{t('validCountryMsg')}
								</span>
							)
						) : undefined
					}
					showBottomLabelSpace={false}
				/>
			) : (
				<MultiSelect
					selectedValues={agentNumbers}
					onChange={(val: any) => multiSelectValidation(val)}
					placeholder={t('agentNum')}
					defaultValue={
						value?.length ? convertStringToArray(value) : undefined
					}
					maxTagCount={5}
					containerMaxHeight={100}
					className={Styles.ipElement}
					onBlur={() => {
						if (modeFilter) {
							if (agentNumbers?.length) {
								validateAgentNumber();
							}
						} else {
							validateAgentNumber();
						}
					}}
					onDeselect={(val: any) => {
						if (agentNumbers?.length) {
							let filteredArray = agentNumbers.filter(
								(e: string) => e !== val
							);
							if (filteredArray?.length) {
								validateAgentNumber(filteredArray);
							}
						} else {
							setChange({
								...change,
								agentNumValid: true,
							});
							setDisable({
								...change,
								agentNumValid: true,
							});
						}
					}}
					bottomLabelType={
						change.hasOwnProperty('agentNumValid')
							? change['agentNumValid']
								? undefined
								: 'error'
							: undefined
					}
					bottomLabel={
						change.hasOwnProperty('agentNumValid') ? (
							change['agentNumValid'] ? undefined : (
								<span>
									<img
										style={{ marginRight: '0.5rem' }}
										src={ErrorIcon}
										className={Styles.errorIcon}
										alt=""
									/>
									{t('validCountryMsg')}
								</span>
							)
						) : undefined
					}
					showBottomLabelSpace={false}
				>
					{agentData &&
						Object.values(agentData).map((option: any) => {
							return (
								<MultiSelectOption key={option} value={option}>
									{option}
								</MultiSelectOption>
							);
						})}
				</MultiSelect>
			)}
		</>
	);
};

export default AgentNumber;
